import React, { Component } from "react";
import {
    Box, Button, Stack, InputLabel,
    MenuItem, Select, TextField, Modal,
    FormControl, RadioGroup, Radio, FormControlLabel, Tooltip, Autocomplete, IconButton, Divider, Typography, Drawer
} from "@mui/material";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { Trans, withTranslation } from 'react-i18next';
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonGridHeader from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import moment from 'moment/moment';
import { DateTime } from 'luxon'

class OTStockTrans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockListData: [],
            originalStockListData: [], 
            isOPT: false,
            patientDetails: [],
            selectedPatient: null,
            selectedUHID: null,
            selectedIPNo: null,
            patientName: '',
            UHID:'',
            IPNo: '',
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            startDate: null,
            dateIndex: 1,
            selected_method: 'Drug',
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        }
    }

    componentDidMount = () => {
        let logginedData = localGetItem('loggedInUserInfo')
        let loggedInUserInfo = JSON.parse(logginedData)
        this.setState({
            isOPT: loggedInUserInfo?.is_opt
        }, () => { this.getStockList(true) })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    buildQueryParams = (extra = {}) => {
        const {
            fromDate,
            toDate,
            patientName,
            UHID,
            IPNo,
        } = this.state;

        return new URLSearchParams({
            brand_name: '',
            generic_name: '',
            from_date: fromDate,
            to_date: toDate,
            patient_name: patientName || '',
            uhid: UHID || '',
            ip_number: IPNo || '',
            ...extra,
        }).toString();
    };

getStockList = (isInitial = false) => {
  try {
    let ServiceURL = this.state.selected_method === "IOL" ? Serviceurls.STOCK_IOL_USAGE_TRANSACTION: Serviceurls.GET_STOCK_USAGE_TRANSACTION

    const queryParams = this.buildQueryParams();

    RestAPIService.getAll(`${ServiceURL}?${queryParams}`)
      .then((response) => {
        if (response.data.status === "success") {
          const dataWithSno = response.data.data.map((row, index) => ({
            ...row,
            sno: index + 1,
          }));

          this.setState(prev => ({
            stockListData: dataWithSno,
            originalStockListData: isInitial
              ? dataWithSno
              : prev.originalStockListData,
          }));
        }
      });
  } catch (e) {
    this.errorMessage(e.message)
  }
};


    getPrintStock = () => {
        try {
            const { selected_method } = this.state;

            if(this.state.stockListData.length === 0) return this.errorMessage("No data found")
            const ServiceURL = selected_method === "IOL"? Serviceurls.STOCK_IOL_USAGE_TRANSACTION: Serviceurls.GET_STOCK_USAGE_TRANSACTION;
            const queryParams = this.buildQueryParams({
                export_type: 'pdf',
            });

            RestAPIService.getAll(`${ServiceURL}?${queryParams}`, {
                responseType: 'blob',
            })
                .then((response) => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                })
                .catch((error) => this.errorMessage(error.message));
        } catch (e) {
            this.errorMessage(e.message)
        }
      }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container' emed_tid="ot_stock_trans_filter_container">
                <Box component={"div"} className='eMed_filter_Top' emed_tid="ot_stock_trans_filter_header">
                    <Typography variant='h6' fontWeight={600} emed_tid="ot_stock_trans_filter_title">{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn' emed_tid="ot_stock_trans_filter_close_btn">
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' emed_tid="ot_stock_trans_filter_close_icon" />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' emed_tid="ot_stock_trans_filter_content">
                    <Box className='eMed_date_filter' emed_tid="ot_stock_trans_filter_date_container">
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true}
                            emed_tid="ot_stock_trans_filter_date_picker" />
                    </Box>
                    {localGetItem('show_active_IP_patient_details') == "true" && localGetItem("isNewBilling") === "true"?
                        <>
                            <Box className='eMed_rts_dropdown'>
                                <TextField
                                    autoComplete='off'
                                    value={this?.state?.patientName}
                                    onChange={(e, value) => {
                                        this.setState({
                                            patientName: e?.target?.value?.slice(0, 50) || '',
                                        });
                                    }}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="Patient Name"
                                     placeholder="Patient Name"
                                    // InputProps={{ style: { height: '4.5dvh' } }}
                                   />
                                
                            </Box>
                            <Box className='eMed_rts_dropdown'>
                                  <TextField
                                    autoComplete='off'
                                    value={this?.state?.UHID}
                                    onChange={(e, value) => {
                                        this.setState({
                                            UHID: e?.target?.value?.slice(0, 20) || '',
                                        });
                                    }}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="UHID"
                                     placeholder="UHID"
                                    // InputProps={{ style: { height: '4.5dvh' } }}
                                   />
                               
                            </Box>

                            <Box className='eMed_rts_dropdown'>
                                <TextField
                                    autoComplete='off'
                                    value={this?.state?.IPNo}
                                    onChange={(e, value) => {
                                        this.setState({
                                          IPNo: e?.target?.value?.slice(0, 20) || '',
                                        });
                                    }}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="IP No"
                                    placeholder="IP No"
                                    // InputProps={{ style: { height: '4.5dvh' } }}
                                   />
                            </Box>

                        </>
                        : null
                    }
                   
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center" emed_tid="ot_stock_trans_filter_buttons">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                doctorName: [], startDate: null,
                                specialization: [], appointmentType: [], patientType: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false,
                                selectedPatient: null,
                                selectedUHID: null,
                                selectedIPNo: null,
                                patientName: "",
                                UHID:"",
                                IPNo:""

                            }, () => this.getStockList())
                        }}
                        id="eMed_Config_btn"
                        emed_tid="ot_stock_trans_filter_clear_btn"
                    >{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getStockList(false)
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn"
                        emed_tid="ot_stock_trans_filter_search_btn"
                    >{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    render() {
        this.state.stockListData.forEach((element, index) => { element.sno = index + 1 })
        const { t } = this.props

        const columns = [
            {
                field: 'sno',
                headerName: t('S.No'),
                sortable: false,
                flex: 0.6,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        {params?.row?.sno}
                    </Box>
                ),
            },
            {
                field: 'date',
                headerName: t('Date'),
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        {params?.row?.date?.split('-').reverse().join('-')}
                    </Box>
                ),
            },

            ...(localGetItem('show_active_IP_patient_details') == "true" && localGetItem("isNewBilling") === "true" ?
                 [
                    {
                        field: 'patient_details',
                        headerName: t('Patient Details'),
                        sortable: false,
                        flex: 2.5,
                        valueGetter: (params) => {
                             const p = params?.row?.patient_details
                             if (!params?.row?.patient_details) return '-';

                             return `${params?.row?.patient_details.patient_name || '-'} ${params?.row?.patient_details.age || '-'} / ${params?.row?.patient_details.gender || '-'} | ${params?.row?.patient_details.uhid || '-'}`;
                         },
                        renderCell: (params) => (
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={1.5}
                                height="100%"
                                width="100%"
                            >
                                <Box flexShrink={0}>
                                    <img
                                        src={params.row?.patient_details?.image || params?.row?.patient_details?.gender === 'm' ? ImagePaths.Male.default : params?.row?.patient_details?.gender === 'f' ? ImagePaths.Female.default : ImagePaths.Male.default}
                                        alt="patient"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            backgroundColor: '#EDFFFE',
                                        }}
                                    />
                                </Box>

                                <Box display="flex" flexDirection="column" minWidth={0}>
                                    {(params?.row?.patient_details?.patient_name?.length) > 20 ?
                                        <Tooltip
                                            title={params?.row?.patient_details?.patient_name || ""}
                                            arrow
                                            disableHoverListener={
                                                (params?.row?.patient_details?.patient_name?.length || 0) <= 20
                                            }
                                        >
                                            <Typography noWrap>
                                                {params?.row?.patient_details?.patient_name ? (
                                                    <>
                                                        {params.row.patient_details?.patient_name?.length > 20
                                                            ? `${params?.row?.patient_details?.patient_name?.slice(0, 20)}...`
                                                            : params.row?.patient_details?.patient_name}

                                                        <span>
                                                            {" "}
                                                            {params?.row?.patient_details?.age}/
                                                            {params?.row?.patient_details?.gender === "m"
                                                                ? "M"
                                                                : params?.row?.patient_details?.gender === "f"
                                                                    ? "F"
                                                                    : "-"}
                                                        </span>
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography >{(params?.row?.patient_details?.patient_name ? params?.row?.patient_details?.patient_name : '-')}<span>{" "}{params?.row?.patient_details?.age}/{params?.row?.patient_details?.gender == 'm' ? "M" : params?.row?.patient_details?.gender == 'f' ? "F" : "-"}</span></Typography>}

                                    <Box display="flex" gap={0.5}>
                                        <Typography variant="body2" color="text.secondary">
                                            {params.row?.patient_details?.uhid ?? '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            | {params?.row?.patient_details?.mobile_number??'-'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ),
                    },

                    {
                        field: 'ip_number',
                        headerName: t('IP No'),
                        valueGetter: (params) =>
                            params?.row?.patient_details?.ip_number || '-',
                        sortable: false,
                        flex: 1.7,
                        headerAlign: 'center',
                        align: 'center',
                        renderCell: (params) => (
                            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                {params?.row?.patient_details?.ip_number ?? '-'}
                            </Box>
                        ),
                    },
                ]
                : []),

            {
                field: 'drug_details',
                headerName: t('Drug Details'),
                sortable: false,
                flex: 2,
                valueGetter: (params) => {
                    if (!params?.row?.patient_details) return '-';

                    return `${params?.row?.brand_name || '-'} | ${params?.row?.generic_name || '-'}`;
                },
                renderCell: (params) => (
                    <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
                        {(params?.row?.brand_name?.length) > 25 ?
                            <Tooltip title={params?.row?.brand_name || ''} placement={'top'} arrow>
                                <Typography fontWeight={500} noWrap >{(params?.row?.brand_name ? ((params?.row?.brand_name?.slice(0, 25) + '...')) : '-')}</Typography>
                            </Tooltip> :
                            <Typography fontWeight={500} noWrap >{(params?.row?.brand_name ? params?.row?.brand_name : '-')}</Typography>}
                        {(params?.row?.generic_name?.length) > 25 ?
                            <Tooltip title={params?.row?.generic_name || ''} placement={'top'} arrow>
                                <Typography variant="body2" color="text.secondary" noWrap >{(params?.row?.generic_name ? ((params?.row?.generic_name?.slice(0, 25) + '...')) : '-')}</Typography>
                            </Tooltip> :
                            <Typography variant="body2" color="text.secondary" noWrap >{(params?.row?.generic_name ? params?.row?.generic_name : '-')}</Typography>}
                    </Box>
                ),
            },

            {
                field: 'batch_no',
                headerName: t('Batch Number'),
                sortable: false,
                flex: 1.1,
                align: 'center',
                headerAlign: 'center',
            },

            {
                field: 'dosage_type',
                headerName: t('Dosage Type'),
                sortable: false,
                flex: 1.1,
                align: 'center',
                headerAlign: 'center',
            },

            {
                field: 'dosage_strength',
                headerName: t('Dosage Strength'),
                sortable: false,
                flex: 1.1,
                align: 'center',
                headerAlign: 'center',
            },

            {
                field: 'usage_quantity',
                headerName: t('Used Quantity'),
                sortable: false,
                flex: 1.1,
                align: 'center',
                headerAlign: 'center',
            },

            {
                field: 'avaliable_quantity',
                headerName: t('Available Quantity'),
                sortable: false,
                flex: 1.1,
                align: 'center',
                headerAlign: 'center',
            },
        ];

        const IOL_columns = [
             {
                field: 'sno',
                headerName: t('S.No'),
                sortable: false,
                flex: 0.6,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        {params?.row?.sno}
                    </Box>
                ),
            },
            {
                field: 'date', headerName: t('Date'), sortable: false, flex: 1, headerAlign: "center", align: "center",
                renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_date_cell_${params.row.sno}`}>{(params.row.date).split("-").reverse().join("-")}</div>)
            },
            ...(localGetItem('show_active_IP_patient_details') == "true" && localGetItem("isNewBilling") === "true" ?
                 [
                    {
                        field: 'patient_details',
                        headerName: t('Patient Details'),
                        sortable: false,
                        flex: 2.5,
                        valueGetter: (params) => {
                             if (!params?.row?.patient_details) return '-';

                             return `${params?.row?.patient_details.patient_name || '-'} ${params?.row?.patient_details.age || '-'} / ${params?.row?.patient_details.gender || '-'} | ${params?.row?.patient_details.uhid || '-'}`;
                         },
                        renderCell: (params) => (
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={1.5}
                                height="100%"
                                width="100%"
                            >
                                <Box flexShrink={0}>
                                    <img
                                        src={params.row?.patient_details?.image || params?.row?.patient_details?.gender === 'm' ? ImagePaths.Male.default : params?.row?.patient_details?.gender === 'f' ? ImagePaths.Female.default : ImagePaths.Male.default}
                                        alt="patient"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            backgroundColor: '#EDFFFE',
                                        }}
                                    />
                                </Box>

                                <Box display="flex" flexDirection="column" minWidth={0}>
                                    {(params?.row?.patient_details?.patient_name?.length) > 20 ?
                                        <Tooltip
                                            title={params?.row?.patient_details?.patient_name || ""}
                                            arrow
                                            disableHoverListener={
                                                (params?.row?.patient_details?.patient_name?.length || 0) <= 20
                                            }
                                        >
                                            <Typography noWrap>
                                                {params?.row?.patient_details?.patient_name ? (
                                                    <>
                                                        {params.row.patient_details?.patient_name?.length > 20
                                                            ? `${params?.row?.patient_details?.patient_name?.slice(0, 20)}...`
                                                            : params.row?.patient_details?.patient_name}

                                                        <span>
                                                            {" "}
                                                            {params?.row?.patient_details?.age}/
                                                            {params?.row?.patient_details?.gender === "m"
                                                                ? "M"
                                                                : params?.row?.patient_details?.gender === "f"
                                                                    ? "F"
                                                                    : "-"}
                                                        </span>
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography >{(params?.row?.patient_details?.patient_name ? params?.row?.patient_details?.patient_name : '-')}<span>{" "}{params?.row?.patient_details?.age}/{params?.row?.patient_details?.gender == 'm' ? "M" : params?.row?.patient_details?.gender == 'f' ? "F" : "-"}</span></Typography>}

                                    <Box display="flex" gap={0.5}>
                                        <Typography variant="body2" color="text.secondary">
                                            {params.row?.patient_details?.uhid ?? '-'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            | {params?.row?.patient_details?.mobile_number??'-'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ),
                    },

                    {
                        field: 'ip_number',
                        headerName: t('IP No'),
                        sortable: false,
                        flex: 1.7,
                        headerAlign: 'center',
                        valueGetter: (params) =>
                            params?.row?.patient_details?.ip_number || '-',
                        align: 'center',
                        renderCell: (params) => (
                            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                {params?.row?.patient_details?.ip_number ?? '-'}
                            </Box>
                        ),
                    },
                ]
                : []),
            {
                field: 'brand_name', headerName: t('BrandName'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_brand_cell_${params.row.sno}`}>{params?.row?.brand_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.brand_name} arrow emed_tid={`ot_stock_trans_iol_brand_tooltip_${params.row.sno}`}><div emed_tid={`ot_stock_trans_iol_brand_truncated_${params.row.sno}`}>{params?.row?.brand_name.slice(0, 14) + "..."}</div></Tooltip> : <div emed_tid={`ot_stock_trans_iol_brand_full_${params.row.sno}`}>{params?.row?.brand_name}</div>}</div>)
            },
            {
                field: 'model_name', headerName: t('Model Name'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_model_cell_${params.row.sno}`}>{params?.row?.model_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.model_name} arrow emed_tid={`ot_stock_trans_iol_model_tooltip_${params.row.sno}`}><div emed_tid={`ot_stock_trans_iol_model_truncated_${params.row.sno}`}>{params?.row?.model_name.slice(0, 14) + "..."}</div></Tooltip> : <div emed_tid={`ot_stock_trans_iol_model_full_${params.row.sno}`}>{params?.row?.model_name}</div>}</div>)
            },
            { field: 'batch_number', headerName: t('BatchNumber'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center', type: "number", renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_batch_cell_${params.row.sno}`}>{params?.row?.batch_number || '-'}</div>) },
            { field: 'iol_type', headerName: t('IOL Type'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center', renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_type_cell_${params.row.sno}`}>{params?.row?.iol_type || '-'}</div>) },
            { field: 'iol_power', headerName: t("IOL Power"), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center', type: "number", renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_power_cell_${params.row.sno}`}>{params?.row?.iol_power || '-'}</div>) },
            { field: 'usage_quantity', headerName: t('Used Quantity'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center', type: "number", renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_usage_quantity_cell_${params.row.sno}`}>{params?.row?.usage_quantity || '-'}</div>) },
            { field: 'avil_quantity', headerName: t('Available Quantity'), sortable: false, flex: 1.1, headerAlign: 'center', align: 'center', type: "number", renderCell: (params) => (<div emed_tid={`ot_stock_trans_iol_available_quantity_cell_${params.row.sno}`}>{params?.row?.avil_quantity || '-'}</div>) }
        ]
        return (
            <div emed_tid="ot_stock_trans_container">
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }} emed_tid="ot_stock_trans_header">
                    <div emed_tid="ot_stock_trans_header_left">
                        <Box component={'div'} className='eMEd_pharma_Home_header' emed_tid="ot_stock_trans_method_section">
                            {this.state.isOPT ? <RadioGroup value={this.state.selected_method}
                                sx={{ display: 'flex', flexDirection: 'row', width: '18vw' }}
                                onClick={(e) => this.setState({ selected_method: e.target.value }, () => { this.getStockList() })}
                                emed_tid="ot_stock_trans_method_radio_group"
                            >
                                <FormControlLabel value={'Drug'} control={<Radio size='small' emed_tid="ot_stock_trans_method_drug_radio" />} label='Drug' emed_tid="ot_stock_trans_method_drug_label" />
                                <FormControlLabel value={'IOL'} control={<Radio size='small' emed_tid="ot_stock_trans_method_iol_radio" />} label='IOL' emed_tid="ot_stock_trans_method_iol_label" />
                            </RadioGroup> : null}
                        </Box>
                    </div>
                    <div className='eMed_Purchase_Table_top' emed_tid="ot_stock_trans_header_right">
                        <div emed_tid="ot_stock_trans_action_buttons">   
                           <Button className='eMed_usrconf_btn' onClick={() => {this.getPrintStock()}} emed_tid="ot_stock_trans_print_btn">
                                <img src={ImagePaths.LabPrintIcon.default} alt="Print" className='eMed_action_img' emed_tid="ot_stock_trans_print_icon" />
                            </Button>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }} emed_tid="ot_stock_trans_filter_btn">
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' emed_tid="ot_stock_trans_filter_icon" />
                            </Button>
                            <Divider orientation='vertical' emed_tid="ot_stock_trans_divider" />
                        </div>
                    </div>
                </div>
                <div className="stock_table_container" emed_tid="ot_stock_trans_table_container">
                    <DataGrid
                        rows={this.state.stockListData}
                        rowCount={this.state.total}
                        page={this.state.page}
                        columns={this.state.selected_method === "IOL" ? IOL_columns : columns}
                        hideFooterSelectedRowCount
                        getRowId={(row) => row["sno"]}
                        pageSize={this.state.pageSize}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: CommonGridHeader.CommonToolBar,
                            NoRowsOverlay: () => (
                                <Stack height="100%" alignItems="center" justifyContent="center" emed_tid="ot_stock_trans_no_records">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        emed_tid="ot_stock_trans_datagrid"
                    />
                </div>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                    emed_tid="ot_stock_trans_filter_drawer"
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="ot_stock_trans_error_toast"
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="ot_stock_trans_success_toast"
                    />
                    : null}
            </div>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}
export default withTranslation()(OTStockTrans);